// =============================================================================
// Subscription Tabs - プラン選択のタブ切り替え機能
// =============================================================================

$(document).on('turbolinks:load', function () {
  const tabs = document.querySelectorAll('.pricing-tab');
  const panels = document.querySelectorAll('.pricing-panel');
  
  if (tabs.length === 0 || panels.length === 0) {
    return; // プラン選択ページでない場合は何もしない
  }
  
  // タブクリック時の処理
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      
      // 全てのタブからactiveクラスを削除
      tabs.forEach(function(t) {
        t.classList.remove('active');
      });
      
      // 全てのパネルからactiveクラスを削除
      panels.forEach(function(panel) {
        panel.classList.remove('active');
      });
      
      // クリックされたタブにactiveクラスを追加
      this.classList.add('active');
      
      // 対応するパネルにactiveクラスを追加
      const targetPanel = document.querySelector('[data-panel="' + targetTab + '"]');
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
      
      // プロプランの価格表示を切り替える
      updatePlanPrice(targetTab);
    });
  });
  
  // キーボードナビゲーション対応
  tabs.forEach(function(tab, index) {
    tab.addEventListener('keydown', function(e) {
      let nextIndex;
      
      switch(e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          nextIndex = index > 0 ? index - 1 : tabs.length - 1;
          tabs[nextIndex].click();
          tabs[nextIndex].focus();
          break;
          
        case 'ArrowRight':
          e.preventDefault();
          nextIndex = index < tabs.length - 1 ? index + 1 : 0;
          tabs[nextIndex].click();
          tabs[nextIndex].focus();
          break;
          
        case 'Home':
          e.preventDefault();
          tabs[0].click();
          tabs[0].focus();
          break;
          
        case 'End':
          e.preventDefault();
          tabs[tabs.length - 1].click();
          tabs[tabs.length - 1].focus();
          break;
      }
    });
  });
  
  // 初期状態の設定（月額プランがデフォルト）
  const monthlyTab = document.querySelector('[data-tab="monthly"]');
  const monthlyPanel = document.querySelector('[data-panel="monthly"]');
  
  if (monthlyTab && monthlyPanel) {
    monthlyTab.classList.add('active');
    monthlyPanel.classList.add('active');
  }
  
  // 初期状態の価格表示を設定（必ず実行）
  updatePlanPrice('monthly');
  
  // プロプランの価格表示を切り替える関数
  function updatePlanPrice(planType) {
    const priceAmount = document.querySelector('.js-plan-card__price-amount');
    const pricePeriod = document.querySelector('.js-plan-card__price-period');
    const priceOriginal = document.querySelector('.js-plan-card__price-original');

    if (priceAmount && pricePeriod) {
      if (planType === 'monthly') {
        priceAmount.textContent = priceAmount.dataset.monthly;
        pricePeriod.textContent = pricePeriod.dataset.monthly;
      } else if (planType === 'yearly') {
        priceAmount.textContent = priceAmount.dataset.yearly;
        pricePeriod.textContent = pricePeriod.dataset.yearly;
      }
    }

    // 限定オファー時の元価格の切り替え
    if (priceOriginal) {
      if (planType === 'monthly') {
        priceOriginal.textContent = priceOriginal.dataset.monthly;
      } else if (planType === 'yearly') {
        priceOriginal.textContent = priceOriginal.dataset.yearly;
      }
    }

    // 限定オファー時の初回限定テキストの切り替え
    var priceFirst = document.querySelector('.js-plan-card__price-first');
    if (priceFirst) {
      if (planType === 'monthly') {
        priceFirst.textContent = priceFirst.dataset.monthly;
      } else if (planType === 'yearly') {
        priceFirst.textContent = priceFirst.dataset.yearly;
      }
    }
  }
});

// =============================================================================
// Accordion - アコーディオン機能（FAQスタイル）
// =============================================================================

$(document).on('turbolinks:load', function () {
  const accordionQuestions = document.querySelectorAll('.accordion-question');
  
  if (accordionQuestions.length === 0) {
    return; // アコーディオンがない場合は何もしない
  }
  
  // アコーディオン質問クリック時の処理
  accordionQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const $accordionItem = $(this).closest('.accordion-item');
      const $answer = $accordionItem.find('.accordion-answer');
      
      // クリックされたアコーディオンを開閉
      $accordionItem.toggleClass('active');
      $answer.slideToggle(300);
      $(this).toggleClass('active');
    });
  });
  
  // キーボードナビゲーション対応
  accordionQuestions.forEach(function(question) {
    question.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
});